/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import VueCompositionAPI from '@vue/composition-api';
import { c as components } from './_chunks/dep-44596e9a.js';
export { Button } from './button/index.js';
export { Icon } from './icon/index.js';
export { Link } from './link/index.js';
export { Col, Row } from './grid/index.js';
export { Aside, Content, Footer, Header, Layout } from './layout/index.js';
export { Divider } from './divider/index.js';
export { Space } from './space/index.js';
export { Affix } from './affix/index.js';
export { Anchor, AnchorItem, AnchorTarget } from './anchor/index.js';
export { Breadcrumb, BreadcrumbItem } from './breadcrumb/index.js';
export { Dropdown, DropdownItem, DropdownMenu } from './dropdown/index.js';
export { Jumper } from './jumper/index.js';
export { HeadMenu, Menu, MenuGroup, MenuItem, Submenu } from './menu/index.js';
export { Pagination } from './pagination/index.js';
export { StepItem, Steps } from './steps/index.js';
export { TabPanel, Tabs } from './tabs/index.js';
export { Cascader, CascaderPanel } from './cascader/index.js';
export { Checkbox, CheckboxGroup } from './checkbox/index.js';
export { ColorPicker, ColorPickerPanel } from './color-picker/index.js';
export { DatePicker, DatePickerPanel, DateRangePicker, DateRangePickerPanel } from './date-picker/index.js';
export { Form, FormItem } from './form/index.js';
export { InputAdornment } from './input-adornment/index.js';
export { Input, InputGroup } from './input/index.js';
export { RangeInput, RangeInputPopup } from './range-input/index.js';
export { InputNumber } from './input-number/index.js';
export { Radio, RadioButton, RadioGroup } from './radio/index.js';
export { Option, OptionGroup, Select } from './select/index.js';
export { Slider } from './slider/index.js';
export { Switch } from './switch/index.js';
export { TagInput } from './tag-input/index.js';
export { SelectInput } from './select-input/index.js';
export { Textarea } from './textarea/index.js';
export { Transfer } from './transfer/index.js';
export { EPickerCols, KeyboardDirection } from './time-picker/interface.js';
export { TimePicker, TimePickerPanel, TimeRangePicker } from './time-picker/index.js';
export { TreeSelect } from './tree-select/index.js';
export { Avatar, AvatarGroup } from './avatar/index.js';
export { Badge } from './badge/index.js';
export { Calendar } from './calendar/index.js';
export { Card } from './card/index.js';
export { Comment } from './comment/index.js';
export { List, ListItem, ListItemMeta } from './list/index.js';
export { LoadingPlugin } from './loading/plugin.js';
export { Loading } from './loading/index.js';
export { Progress } from './progress/index.js';
export { Skeleton } from './skeleton/index.js';
export { Swiper, SwiperItem } from './swiper/index.js';
export { BaseTable, EnhancedTable, PrimaryTable, Table } from './table/index.js';
export { CheckTag, Tag } from './tag/index.js';
export { Tooltip } from './tooltip/index.js';
export { Tree } from './tree/index.js';
export { Collapse, CollapsePanel } from './collapse/index.js';
export { Alert } from './alert/index.js';
export { DialogPlugin } from './dialog/plugin.js';
export { Dialog } from './dialog/index.js';
export { Drawer } from './drawer/index.js';
export { MessagePlugin } from './message/plugin.js';
export { Message } from './message/index.js';
export { NotificationPlugin, NotifyPlugin } from './notification/plugin.js';
export { Notification } from './notification/index.js';
export { Popconfirm } from './popconfirm/index.js';
export { Popup } from './popup/index.js';
export { Upload } from './upload/index.js';
export { ConfigProvider } from './config-provider/index.js';
import './button/button.js';
import '@babel/runtime/helpers/defineProperty';
import './button/props.js';
import './utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import './utils/ripple.js';
import './_common/js/utils/set-style.js';
import './config.js';
import './config-provider/config-receiver.js';
import 'lodash/mergeWith';
import './config-provider/context.js';
import 'lodash/merge';
import './_common/js/global-config/default-config.js';
import './_common/js/global-config/locale/zh_CN.js';
import './config-provider/type.js';
import './utils/mixins.js';
import './loading/loading.js';
import './loading/icon/gradient.js';
import './_common/js/loading/circle-adapter.js';
import './_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import './utils/dom.js';
import 'raf';
import 'lodash/isString';
import './utils/easing.js';
import './utils/transfer-dom.js';
import './loading/props.js';
import './utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import './loading/type.js';
import './button/type.js';
import 'tdesign-icons-vue';
import './link/link.js';
import './link/props.js';
import './link/type.js';
import './grid/col.js';
import 'lodash/isObject';
import './utils/responsive.js';
import './grid/col-props.js';
import './grid/row.js';
import './_chunks/dep-ca50338e.js';
import './grid/row-props.js';
import './grid/type.js';
import './layout/layout.js';
import './layout/header.js';
import './layout/header-props.js';
import './layout/footer.js';
import './layout/footer-props.js';
import './layout/aside.js';
import './layout/aside-props.js';
import './layout/content.js';
import './layout/type.js';
import './divider/divider.js';
import './divider/props.js';
import './divider/type.js';
import './space/space.js';
import './space/props.js';
import './hooks/useConfig.js';
import './config-provider/useConfig.js';
import './space/type.js';
import './affix/affix.js';
import 'lodash/isFunction';
import './affix/props.js';
import './affix/type.js';
import './anchor/anchor.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import './anchor/utils.js';
import './anchor/props.js';
import './anchor/anchor-item.js';
import './anchor/anchor-item-props.js';
import './anchor/anchor-target.js';
import './utils/clipboard.js';
import 'clipboard';
import './anchor/anchor-target-props.js';
import './message/messageList.js';
import './message/const.js';
import './message/message.js';
import './message/props.js';
import './message/animation.js';
import './popup/popup.js';
import '@popperjs/core';
import './utils/helper.js';
import './popup/props.js';
import './popup/container.js';
import './utils/map-props.js';
import './popup/type.js';
import './anchor/type.js';
import './breadcrumb/breadcrumb.js';
import './breadcrumb/props.js';
import './breadcrumb/breadcrumb-item.js';
import './breadcrumb/breadcrumb-item-props.js';
import './tooltip/tooltip.js';
import './tooltip/props.js';
import './tooltip/type.js';
import './breadcrumb/type.js';
import './dropdown/dropdown-item.js';
import './dropdown/dropdown-item-props.js';
import './utils/event.js';
import './dropdown/dropdown.js';
import './dropdown/dropdown-menu.js';
import './dropdown/props.js';
import './dropdown/type.js';
import './jumper/jumper.js';
import './jumper/props.js';
import './hooks/useGlobalIcon.js';
import './jumper/type.js';
import './menu/menu.js';
import './menu/props.js';
import './menu/v-menu.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import './menu/head-menu.js';
import './menu/head-menu-props.js';
import './tabs/tabs.js';
import './tabs/props.js';
import './tabs/tab-panel.js';
import './tabs/tab-panel-props.js';
import './hooks/useDestroyOnClose.js';
import './tabs/tab-nav.js';
import 'lodash/debounce';
import './tabs/tab-nav-item.js';
import './tabs/type.js';
import './menu/submenu.js';
import './menu/submenu-props.js';
import './common-components/fake-arrow.js';
import './menu/menu-item.js';
import './menu/menu-item-props.js';
import './menu/menu-group.js';
import './menu/menu-group-props.js';
import './menu/type.js';
import './pagination/pagination.js';
import './pagination/props.js';
import './input-number/input-number.js';
import './input-number/props.js';
import './input-number/useInputNumber.js';
import './hooks/useCommonClassName.js';
import './hooks/useVModel.js';
import './_common/js/input-number/number.js';
import 'lodash/isNumber';
import './_common/js/input-number/large-number.js';
import './_common/js/log/log.js';
import './_common/js/log/index.js';
import './hooks/useFormDisabled.js';
import './input/input.js';
import './input/props.js';
import './input/input-group.js';
import './input/type.js';
import './input-number/type.js';
import './select/select.js';
import 'lodash/get';
import 'lodash/cloneDeep';
import 'lodash/isArray';
import './hooks/useDefaultValue.js';
import './hooks/tnode.js';
import 'lodash/isEmpty';
import './hooks/render-tnode.js';
import './select/props.js';
import './select/option.js';
import './select/option-props.js';
import './hooks/useLazyLoad.js';
import './_common/js/utils/observe.js';
import './select/util.js';
import './checkbox/group.js';
import 'lodash/intersection';
import './checkbox/checkbox.js';
import './checkbox/props.js';
import './checkbox/checkbox-group-props.js';
import './checkbox/type.js';
import './select/select-panel.js';
import './hooks/useVirtualScroll.js';
import './select/hooks/useSelectOptions.js';
import './tag/tag.js';
import './tag/props.js';
import './tag/check-tag.js';
import './tag/check-tag-props.js';
import './tag/type.js';
import './select-input/select-input.js';
import './select-input/props.js';
import './select-input/useSingle.js';
import 'lodash/pick';
import './select-input/useMultiple.js';
import './tag-input/tag-input.js';
import './tag-input/props.js';
import './tag-input/hooks/useTagScroll.js';
import './tag-input/useTagList.js';
import './tag-input/hooks/useHover.js';
import './tag-input/hooks/useDragSorter.js';
import './tag-input/type.js';
import './select-input/useOverlayInnerStyle.js';
import './select-input/type.js';
import './select/optionGroup.js';
import './select/option-group-props.js';
import './select/type.js';
import './input-adornment/input-adornment.js';
import './input-adornment/props.js';
import './input-adornment/type.js';
import './pagination/type.js';
import './steps/steps.js';
import './steps/props.js';
import './steps/step-item.js';
import './steps/step-item-props.js';
import './steps/type.js';
import './cascader/cascader.js';
import './cascader/components/Panel.js';
import './cascader/components/Item.js';
import './cascader/core/helper.js';
import './cascader/core/className.js';
import './cascader/props.js';
import './cascader/core/effect.js';
import './cascader/hooks.js';
import 'lodash/isEqual';
import './_common/js/tree/tree-store.js';
import 'lodash/difference';
import 'lodash/isPlainObject';
import './_common/js/tree/tree-node.js';
import 'lodash/uniqueId';
import 'lodash/isNil';
import './_common/js/tree/tree-node-model.js';
import 'lodash/omit';
import './cascader/cascader-panel.js';
import './cascader/type.js';
import './color-picker/color-picker-panel.js';
import './color-picker/props.js';
import './color-picker/panel/index.js';
import './color-picker/const.js';
import './_common/js/color-picker/constants.js';
import './color-picker/panel/header.js';
import './color-picker/hooks.js';
import './radio/radio.js';
import './radio/props.js';
import './radio/group.js';
import './radio/radio-group-props.js';
import './radio/radio-button.js';
import './radio/type.js';
import './color-picker/panel/linear-gradient.js';
import './color-picker/utils/index.js';
import './_common/js/color-picker/index.js';
import './_common/js/color-picker/cmyk.js';
import './_common/js/color-picker/color.js';
import 'tinycolor2';
import './_common/js/color-picker/gradient.js';
import './_common/js/color-picker/draggable.js';
import './color-picker/panel/base-props.js';
import './color-picker/panel/saturation.js';
import './color-picker/panel/hue.js';
import './color-picker/panel/slider.js';
import './color-picker/panel/alpha.js';
import './color-picker/panel/format/index.js';
import 'lodash/upperCase';
import './color-picker/panel/format/inputs.js';
import 'lodash/throttle';
import './color-picker/panel/format/config.js';
import './color-picker/panel/swatches.js';
import 'lodash';
import './color-picker/color-picker.js';
import './color-picker/trigger.js';
import './color-picker/type.js';
import './date-picker/DatePicker.js';
import 'dayjs';
import './date-picker/hooks/useSingle.js';
import './date-picker/hooks/useFormat.js';
import './_common/js/date-picker/utils.js';
import '@babel/runtime/helpers/extends';
import './_chunks/dep-f86939ed.js';
import './_chunks/dep-7ea7a277.js';
import 'lodash/chunk';
import './date-picker/hooks/useSingleValue.js';
import './date-picker/props.js';
import './date-picker/panel/SinglePanel.js';
import './date-picker/panel/PanelContent.js';
import './date-picker/base/Header.js';
import './date-picker/base/Table.js';
import './date-picker/base/Cell.js';
import './time-picker/panel/time-picker-panel.js';
import './_common/js/time-picker/const.js';
import './time-picker/panel/props.js';
import './time-picker/props.js';
import './time-picker/panel/single-panel.js';
import 'lodash/range';
import 'lodash/padStart';
import './_common/js/time-picker/utils.js';
import './date-picker/panel/ExtraContent.js';
import './date-picker/base/Footer.js';
import './date-picker/hooks/useTableData.js';
import './date-picker/hooks/useDisableDate.js';
import './date-picker/DatePickerPanel.js';
import './date-picker/date-picker-panel-props.js';
import './date-picker/DateRangePicker.js';
import './date-picker/date-range-picker-props.js';
import './date-picker/panel/RangePanel.js';
import './date-picker/hooks/useRange.js';
import './date-picker/hooks/useRangeValue.js';
import './range-input/range-input.js';
import './range-input/props.js';
import './range-input/range-input-popup.js';
import './range-input/range-input-popup-props.js';
import './range-input/type.js';
import './date-picker/DateRangePickerPanel.js';
import './date-picker/date-range-picker-panel-props.js';
import './date-picker/type.js';
import './form/form.js';
import './form/props.js';
import './form/const.js';
import './form/form-item.js';
import 'lodash/set';
import 'lodash/template';
import './form/form-model.js';
import './form/form-item-props.js';
import './form/type.js';
import './slider/slider.js';
import './slider/props.js';
import './slider/slider-mark.js';
import './slider/slider-button.js';
import './slider/type.js';
import './switch/switch.js';
import './switch/props.js';
import './switch/type.js';
import './textarea/textarea.js';
import './textarea/props.js';
import './textarea/calcTextareaHeight.js';
import './textarea/type.js';
import './transfer/transfer.js';
import './transfer/components/transfer-list.js';
import './transfer/utils.js';
import './transfer/components/transfer-search.js';
import './transfer/components/transfer-operations.js';
import './transfer/props.js';
import './transfer/interface.js';
import './transfer/type.js';
import './time-picker/type.js';
import './time-picker/time-picker.js';
import './time-picker/time-range-picker.js';
import './time-picker/time-range-picker-props.js';
import './tree-select/tree-select.js';
import 'lodash/isBoolean';
import './tree-select/props.js';
import './tree/td-tree.js';
import 'lodash/upperFirst';
import './tree/tree-item.js';
import './tree/util.js';
import './tree/props.js';
import './tree/interface.js';
import './tree/type.js';
import './tree-select/interface.js';
import './tree-select/type.js';
import './avatar/avatar.js';
import './avatar/props.js';
import './avatar/group.js';
import './avatar/avatar-group-props.js';
import './avatar/type.js';
import './badge/badge.js';
import './badge/props.js';
import './badge/type.js';
import './calendar/calendar.js';
import './calendar/props.js';
import './calendar/utils.js';
import './calendar/const.js';
import './calendar/calendar-cell.js';
import './utils/render-component.js';
import './calendar/interface.js';
import './calendar/type.js';
import './card/card.js';
import './card/props.js';
import './card/type.js';
import './comment/comment.js';
import './comment/props.js';
import './comment/type.js';
import './list/list.js';
import './list/props.js';
import './list/const.js';
import './list/list-item.js';
import './list/list-item-props.js';
import './list/list-item-meta.js';
import './list/list-item-meta-props.js';
import './list/type.js';
import './progress/progress.js';
import './progress/constants.js';
import './progress/props.js';
import './progress/type.js';
import './skeleton/skeleton.js';
import './skeleton/props.js';
import './skeleton/type.js';
import './swiper/swiper.js';
import './swiper/props.js';
import './swiper/swiper-item.js';
import './swiper/type.js';
import './table/base-table.js';
import './table/base-table-props.js';
import './table/hooks/useTableHeader.js';
import './table/hooks/useMultiHeader.js';
import './table/hooks/useClassName.js';
import './table/ellipsis.js';
import './table/hooks/useColumnResize.js';
import './table/hooks/useFixed.js';
import './_common/js/utils/getScrollbarWidth.js';
import './table/hooks/usePagination.js';
import './table/hooks/useAffix.js';
import './table/tbody.js';
import './table/tr.js';
import './table/utils.js';
import './table/hooks/useRowspanAndColspan.js';
import './table/hooks/useStyle.js';
import './table/thead.js';
import './table/tfoot.js';
import './table/primary-table.js';
import './table/primary-table-props.js';
import './table/hooks/useColumnController.js';
import './dialog/dialog.js';
import './dialog/actions.js';
import './dialog/props.js';
import './dialog/stack.js';
import './table/hooks/useRowExpand.js';
import './table/hooks/useRowSelect.js';
import './table/hooks/useSorter.js';
import './table/sorter-button.js';
import './table/hooks/useFilter.js';
import './table/filter-controller.js';
import 'lodash/lowerFirst';
import './table/hooks/useDragSort.js';
import 'sortablejs';
import './_common/js/utils/swapDragArrayElement.js';
import './table/hooks/useAsyncLoading.js';
import './table/hooks/useEditableCell.js';
import './table/editable-cell.js';
import './table/hooks/useEditableRow.js';
import './table/enhanced-table.js';
import './table/enhanced-table-props.js';
import './table/hooks/useTreeData.js';
import './table/hooks/tree-store.js';
import './table/hooks/useTreeSelect.js';
import './table/type.js';
import './table/interface.js';
import './collapse/collapse.js';
import './collapse/props.js';
import './collapse/collapse-panel.js';
import './collapse/collapse-panel-props.js';
import './collapse/useCollapseAnimation.js';
import './collapse/type.js';
import './alert/alert.js';
import './alert/props.js';
import './alert/type.js';
import './dialog/type.js';
import './drawer/drawer.js';
import './drawer/props.js';
import './drawer/type.js';
import './message/type.js';
import './notification/notificationList.js';
import './notification/notification.js';
import './notification/props.js';
import './notification/const.js';
import './notification/type.js';
import './popconfirm/popconfirm.js';
import './popconfirm/props.js';
import './popconfirm/type.js';
import './upload/upload.js';
import 'lodash/findIndex';
import 'lodash/without';
import './upload/dragger.js';
import './_common/js/upload/utils.js';
import './upload/props.js';
import './upload/image.js';
import './upload/flow-list.js';
import './_common/js/upload/xhr.js';
import './upload/single-file.js';
import './upload/interface.js';
import './upload/type.js';
import './config-provider/config-provider.js';

function install(Vue, config) {
  if (Vue._installedPlugins.indexOf(VueCompositionAPI) === -1) {
    Vue.use(VueCompositionAPI);
  }

  Object.keys(components).forEach(function (key) {
    if (components[key]) {
      /plugin/i.test(key) ? Vue.use(components[key]) : Vue.use(components[key], config);
    }
  });
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
var index = {
  install: install,
  version: typeof "0.46.2" === "undefined" ? "" : "0.46.2"
};

export { index as default };
//# sourceMappingURL=index.js.map
